// Copyright ©️ 2026 eVolve MEP, LLC

import { Text } from '@mantine/core';

import type { ModalRegistryManagedProps } from 'components/Mantine/Modals/createModalRegistry';
import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';

type Props = ModalRegistryManagedProps & {
  title: string;
  /** The backend's explanation of why the action was refused. */
  message: string;
};

export const WorkOrderActionBlockedModal = ({ onClose, title, message, ...props }: Props) => (
  <WrappedModal
    title={title}
    titleIcon="Alert"
    titleIconColor="red"
    onClose={onClose}
    onConfirm={onClose}
    closeOnConfirm={false}
    withCancelButton={false}
    {...props}
  >
    <Text>{message}</Text>
  </WrappedModal>
);
